import { useState } from "react";
import { useTranslation } from "react-i18next";
import { post } from "../_request";
import { useToast } from "../../modules/layout/components/ToastContext";

interface Props {
    targetProfileId: string;
}

export default function SendResetPassword({ targetProfileId }: Props) {
    const { t } = useTranslation();
    const { showToast } = useToast();
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);

    const handleSendResetPassword = async () => {
        if (!targetProfileId) {
            showToast( t("InvalidProfile"), "error");
            return;
        }

        try {
            setLoading(true);
            
            const apiUrl = `/api/UserEvents/sendresetpasswordsms?targetProfileId=${encodeURIComponent(targetProfileId)}`;
            const result = await post(apiUrl, null);

            if (result?.data) {
                showToast(
                    t("ResetPasswordSmsSent"), "success"
                );
            } else {
                showToast( t("ResetPasswordSmsFailed"), "error");
            }
       } catch (err: any) {
        console.error(err);
        setError(String(err?.message ?? err));
        showToast && showToast(t('ConnectionError', { error: String(err) }), 'error');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="gg-profile-action">
           <div className="d-flex align-items-center mb-2">
                
                <h6 className="gg-profile-action__title mb-0"> 
                    {t("SendResetPasswordSms")}:
                </h6>
                <i className="bi bi-info-circle ms-2 text-muted" data-bs-toggle="tooltip" title={t('SendResetPassSmsInfo')} style={{ cursor: "pointer" }}></i>
            </div>
            
            <button className="btn btn-outline-primary w-100"
                    onClick={handleSendResetPassword}
                    disabled={loading}>
                        {loading ? t("Sending") : t("ResetPasswordSmsLink")}
            </button>
        </div>
    );
}
